<script>
import VLeaseDeadlinesModal from "./VLeaseDeadlinesModal.vue";

export default {
    components: { VLeaseDeadlinesModal },
    props: {
        land_lease: { type: Object, required: true }
    },
    data() {
        return {
            showDeadlinesModal: false,
            openAddForm: false
        };
    },
    computed: {
        activeDeadlines() {
            return (this.land_lease.land_lease_deadlines || []).filter(
                dl => !dl.completed
            );
        }
    },
    methods: {
        dotColor(dl) {
            if (dl.completed) return "text-success";
            if (dl.deadline_status === "passed") return "text-danger";
            if (dl.deadline_status === "warning") return "text-warning";
            return "text-primary";
        },
        openModal(withAddForm) {
            this.openAddForm = !!withAddForm;
            this.showDeadlinesModal = true;
        },
        closeModal() {
            this.showDeadlinesModal = false;
            this.openAddForm = false;
        }
    }
};
</script>

<template>
    <div>
        <h4>{{ $t("land_leases.deadlines") }}</h4>
        <div v-if="activeDeadlines.length">
            <div
                v-for="dl in activeDeadlines"
                :key="dl.id"
                class="d-flex align-items-center mb-1"
            >
                <div class="dl-dot">
                    <i class="fas fa-circle fa-xs" :class="dotColor(dl)"></i>
                </div>
                <div class="dl-name">
                    {{ dl.deadline_name }}
                </div>
                <div class="dl-date text-muted">
                    {{ $d(new Date(dl.deadline_date), "short") }}
                </div>
            </div>
            <base-button
                size="sm"
                type="primary"
                outline
                class="mt-2"
                @click="openModal(false)"
            >
                {{ $t("land_leases.see_all_deadlines") }}
            </base-button>
        </div>
        <div v-else>
            <div class="text-muted">
                {{ $t("land_leases.no_deadlines") }}
            </div>
            <base-button
                size="sm"
                type="primary"
                outline
                class="mt-2"
                @click="openModal(true)"
            >
                {{ $t("land_leases.add_deadline") }}
            </base-button>
        </div>

        <portal to="modals">
            <v-lease-deadlines-modal
                v-if="showDeadlinesModal"
                :land-lease="land_lease"
                :init-add-form="openAddForm"
                @close="closeModal"
            />
        </portal>
    </div>
</template>

<style scoped>
.dl-dot {
    flex: 0 0 20px;
}
.dl-name {
    flex: 1 1 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.dl-date {
    flex: 0 0 auto;
}
</style>
